module.exports = __webpack_public_path__ + "static/media/build_in_the_stock.edbda6b7.svg";